import React from "react";
import { Link } from "react-router-dom";

export const ItemsBloqueHome = ({
    className,
    logo,
    logoStyle,
    texto,
    href,
    to,
    action
}) => {
    const arrow = <span className="btn-arrow-triangle" />;

    const buttonContent = (
        <button className="row mb-half mb-xl-0" onClick={action}>
            {logo && (
                <div className="col-4">
                    <img className="logo" src={logo} style={logoStyle} />
                </div>
            )}
            <div className="col-8 d-flex align-items-center justify-content-end">
                <p>{texto}</p>
                {arrow}
            </div>
        </button>
    );

    return (
        <>
            {href ? (
                <a target="_blank" className="btn-bloqueHome d-flex justify-content-center" href={href}>
                    {buttonContent}
                </a>
            ) : to ? (
                <Link className="btn-bloqueHome d-flex justify-content-center" to={to}>
                    {buttonContent}
                </Link>
            ) : (
                <div className="btn-bloqueHome d-flex justify-content-center">
                    {buttonContent}
                </div>
            )}
        </>
    );
};
